import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material';
import { AuthProvider } from './context/AuthContext';

const theme = createTheme({
  palette: {
    primary: {
      main: "#15185bff",
    },
    secondary: {
      main: "#f97b22ff",
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
    <ThemeProvider theme={theme}>
    <SnackbarProvider>
    <App />
    </SnackbarProvider>
    </ThemeProvider>
    </AuthProvider>
);


